<template>
    <div class="loading-spinner">
        <div class="loading-spinner-body">
            <div class="spinner-box"></div>
            <h5 class="label">{{ label }}</h5>
            <p>Loading...</p>
        </div>
        
    </div>
</template>

<script>
export default {
    name: "loading-spinner",
    props: [
        "height",
        "label"
    ]
}
</script>

<style>

.loading-spinner {
    display: flex;
    justify-content: center;
}

.spinner-box {
    margin: 20px;
    width: 75px; 
    height: 75px;    
    background: rgb(185, 185, 185);
    animation: spin 3s infinite linear;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
}

.loading-spinner-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.loading-spinner-body h5 {
    margin-top: 15px;
    margin-bottom: 5px;
}

.loading-spinner-body p {
    font-size: 15px;
}

@keyframes spin {
    0%  {-webkit-transform: rotate(0deg);}
    100% {-webkit-transform: rotate(360deg);}   
}

.label {
    font-size: 20px;
    font-weight: bold;
}

</style>